import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4c8a7a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-monitor" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "基本信息", -1))
const _hoisted_8 = { class: "descriptions-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "供水类型:", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "descriptions-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "水源地类型:", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "descriptions-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在镇街:", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "descriptions-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "设计供水规模:", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "descriptions-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "有效蓄水水量:", -1))
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "descriptions-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否划分保护区:", -1))
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "descriptions-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "水质监测", -1))
const _hoisted_29 = { class: "descriptions-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测类型:", -1))
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "descriptions-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测方式:", -1))
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { class: "descriptions-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "目标水质:", -1))
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "descriptions-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "当前水质：", -1))
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "descriptions-item2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "主要污染物：", -1))
const _hoisted_43 = { class: "value" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "descriptions-group"
}

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
import { Api, DmYzDatumLineQuery } from '@/api/publicApi'

const max = null

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogDrinkingWater',
  props: {
  // eslint-disable-next-line no-undef
  data: Object,
},
  setup(__props) {

const api = new Api()
const props = __props
// eslint-disable-next-line no-undef
// if (!props.data.value && props.data.value !== 0) {
//   // eslint-disable-next-line vue/no-mutating-props
//   props.data.value = 1
// }
const { data } = toRefs(props)
const { proxy } = getCurrentInstance()
const chart = ref()
let myChart = {}
const testY = []
const testX = []
const active = ref('')
// if (myChart) {
//   myChart.clear()
// }

// for(let i=0;i<props.data..data.length;i++) {}

const option = {
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'item',
  },
  grid: {
    show: true,
    top: 40,
    left: 40,
    right: 45,
    bottom: 60,
    borderWidth: '0',
  },
  yAxis: {
    name: 'mg/L',
    nameTextStyle: {
      fontSize: 14,
      color: '#ffffff',
    },
    show: true,
    type: 'value',
    min: 0,
    max,
    splitLine: {
      show: true,
      lineStyle: {
        width: 2,
        dashOffset: 10,
        type: 'dashed',
        color: 'rgba(230, 247, 255, 0.2)',
      },
    },
    axisLabel: {
      formatter: '{value}',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  xAxis: {
    data: testX,
    boundaryGap: false,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#ffffff',
      },
    },

    axisLabel: {
      type: 'category',
      formatter: '{value}',
      rotate: '45',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  series: [
    {
      name: '监测值(mg/L)',
      type: 'line',
      color: '#09CEA5',
      smooth: false, // 关键点，为true是不支持虚线，实线就用true
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
            type: 'dotted', // 'dotted'虚线 'solid'实线
          },
        },
      },
      // markLine: {
      //   symbol: 'none',
      //   data: [
      //     {
      //       yAxis: 0.6,
      //       valueIndex: 1,
      //       // coord:['60','7'],
      //       lineStyle: {
      //         normal: {
      //           color: '#fd0',
      //           type: 'dashed',
      //         },
      //       },
      //       label: {
      //         normal: {
      //           // show: false,
      //           color: '#fd0',
      //           formatter: '标准值'
      //         },
      //       },
      //     },
      //   ],
      // },
      lineWidth: 2,
      symbol: '',
      symbolSize: 10,
      data: testY,
    },
  ],
}

// 获取图表数据
const getChartData = (data) => {
  active.value = data.name
  option.xAxis.data = data.xaxis
  option.series[0].data = data.trend
  const params: DmYzDatumLineQuery = {
    code: data.code,
    bzszlb: props.data.targetSzn,
    stlx: props.data.stlx,
  }
  api.screen.getDmYzDatumLineUsingPost(params).then((res) => {
    if (res.code === 200) {
      let flag
      for (let i = 0; i < data.trend.length; i++) {
        if (res.data && res.data.datumLine && data.trend[i] > res.data.datumLine) {
          flag = true
          break
        }
      }
      if (!flag && res.data && res.data.datumLine) {
        option.yAxis.max = res.data.datumLine
      }
      if (res.data && res.data.datumLine) {
        option.series[0].markLine = {
          symbol: 'none',
          data: [
            {
              yAxis: res.data.datumLine,
              valueIndex: 1,
              // coord:['60','7'],
              lineStyle: {
                normal: {
                  color: '#fd0',
                  type: 'dashed',
                },
              },
              label: {
                normal: {
                  // show: false,
                  color: '#fd0',
                  formatter: '标准值',
                },
              },
            },
          ],
        }
      } else {
        option.series[0].markLine = null
      }
      myChart.setOption(option)
    }
  })
}

const changeCode = (data) => {
  getChartData(data)
}

getChartData(props.data.data[0])

// nextTick(() => {
//   myChart.setOption(option)
// })
onMounted(() => {
  console.log(chart.value)
  myChart = proxy.$echarts.init(chart.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).dmmc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(data).zdlx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(data).yysydlx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(data).szzj || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(data).zkr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(data).fhkr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("span", _hoisted_25, "是", 512), [
              [_vShow, _unref(data).bhq]
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_26, "否", 512), [
              [_vShow, !_unref(data).bhq]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(data).monitorType || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(data).monitorFunc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(data).targetSz || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(data).nowSz || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(data).skbhfwmj || '-'), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.data, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("span", {
              key: index,
              class: _normalizeClass(["code-btn", item.name == _unref(active) ? 'active' : '']),
              onClick: ($event: any) => (changeCode(item))
            }, _toDisplayString(item.name), 11, _hoisted_44)), [
              [_vShow, item.name]
            ])
          }), 128))
        ]),
        (_unref(data).data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", {
                ref_key: "chart",
                ref: chart,
                class: "chart"
              }, null, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})